import { useDocumentTitle } from '../lib/useDocumentTitle';
import { AppCta } from '../components/AppCta';

/**
 * The `/` route on api.skiffs.app.
 *
 * NOT the marketing site — that's skiffs.app (SK-189), which this page is
 * `rel=canonical` + `noindex` to (pb_public_fallback.pb.js). This page still
 * renders for real visitors, though: it is the landing spot for every share
 * and deep link this host serves, reached by someone opening the app's own
 * link before a device has the app installed.
 *
 * Copy mirrors the marketing site's current hero (SK-219) rather than the
 * tagline it replaced as the opening line. The two pages drifted once already
 * — this one kept "Don't Row Alone." as its <h1> after skiffs.app moved that
 * line to a closing section — and a visitor bouncing between the two in one
 * session is a worse experience than either page alone. The tagline still
 * appears; it's just not the opener anymore.
 */
export function Home() {
  useDocumentTitle("Skiffs — Don't Row Alone");
  return (
    <article className="skf-card">
      <h1 className="skf-title">The worst way to do anything hard is alone.</h1>
      <p className="skf-subtitle">
        Skiffs is for people already headed the same direction. Set a goal, gather a crew, and check
        in daily — because the thing that gets you out the door is knowing someone will notice if
        you don&rsquo;t.
      </p>
      {/*
        Was two hand-written anchors pointing at `apps.apple.com/app/skiffs` (not
        a real App Store URL — Apple addresses apps by numeric id) and a Play
        listing for an app that isn't published yet. AppCta already carries the
        SK-203 fix for exactly this — a real deep-link/store-link matrix that
        falls back to an honest "private beta" line pre-launch — and this page
        had never been switched over to it.
      */}
      <AppCta deepLink={null} />
      <p className="skf-meta">Don&rsquo;t Row Alone.</p>
    </article>
  );
}
